import React from "react";
import "../../styles/Home-page-component/MethodologySection.css";

const MethodologySection = () => {
  return (
    <section className="methodology-section">

      <div className="container methodology-container">

        {/* LEFT SIDE */}
        <div className="methodology-left">

          <span className="methodology-badge">
            OUR PROCESS
          </span>

          <h2 className="methodology-title">
            Transforming Ideas into
            <br />
            Scalable AI Systems
          </h2>

          <p className="methodology-desc">
            We design and deliver intelligent, scalable, and cloud-native systems
            using a proven engineering methodology powered by AI.
          </p>

          {/* <button className="primary-btn">
            Explore Process →
          </button> */}

        </div>

        {/* RIGHT SIDE VISUAL */}
        <div className="methodology-right">

          <div className="visual-card">

            <div className="center-node">AI</div>

            {/* ORBIT 1 */}
            <div className="orbit orbit-1">
              <div className="orbit-dot"></div>
            </div>

            {/* ORBIT 2 */}
            <div className="orbit orbit-2">
              <div className="orbit-dot"></div>
            </div>

          </div>

        </div>

      </div>

      {/* FEATURES ROW */}
      <div className="methodology-features container">

        <div className="feature-item">
          <h4>Discovery & Strategy</h4>
          <p>Understanding business needs and defining clear AI opportunities</p>
        </div>

        <div className="feature-item">
          <h4>Architecture Design</h4>
          <p>Building scalable cloud-native and AI-driven system blueprints</p>
        </div>

        <div className="feature-item">
          <h4>Agile Development</h4>
          <p>Rapid iteration with continuous integration and deployment</p>
        </div>

        <div className="feature-item">
          <h4>Optimization & Scale</h4>
          <p>Monitoring, automation, and performance tuning at enterprise scale</p>
        </div>

      </div>

    </section>
  );
};

export default MethodologySection;